import { MprcFeedTypography } from "components/MprcFeedTypography";
import { Formaters } from "lib/Formaters";
import { useTranslation } from "react-i18next";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

export const ContentBlocked = () => {
    const {
        pub: { blocked },
    } = useCardContext();
    const { t } = useTranslation("knowledge");

    return blocked?.blockedOn
        ? (
            <>
                <MprcFeedTypography variant="content" component="div">
                    <span>{`${t("Feed.Card.Common.ContentBlockedText")} ${Formaters.relativeTime(blocked!.blockedOn!)}`}</span>
                </MprcFeedTypography>
            </>
        )
        : null;
};
